<template>
     <footer class="footer">
         <div class="footer__container container-fluid">
             <div class="footer__item text-start d-none d-md-block"></div>
             <div class="footer__item text-center">{{ new Date().getFullYear() }} &copy;&nbsp;Все права защищены</div>
             <div class="footer__item text-end hover-underline d-none d-md-block" href="/"></div>
         </div>
     </footer>
</template>

<script>
export default {
    name: "FooterComponent",
    props: {
         route_logout: String
    }
}
</script>
